import { simplePath } from "../../utils.js";
import { changeOrganizationName } from "./validations.js";
const UPDATE_ORG_NAME = 'v2/organization/:organization/name';
function get_org_name_path(params) {
    return simplePath(UPDATE_ORG_NAME, params);
}
const schema = changeOrganizationName;
export { UPDATE_ORG_NAME, get_org_name_path, schema };
